import React from "react";
import { Quote } from "lucide-react";

const items = [
  {
    title: "Premier test host-response autorisé FDA",
    quote:
      "MeMed BV® est le premier test de réponse immunitaire de l'hôte à avoir reçu une autorisation 510(k) de la FDA pour distinguer les infections bactériennes des infections virales chez l'adulte et l'enfant.",
    src: "FDA · 510(k) Clearance K230944 [1,2]",
  },
  {
    title: "Réduction des prescriptions antibiotiques",
    quote:
      "Études cliniques et données réelles : MeMed BV influence positivement la décision thérapeutique dans une large majorité des cas où une hésitation diagnostique est présente — un levier concret pour l'Antibiotic Stewardship.",
    src: "Singer et al., JUNO RCT, Academic Emergency Medicine, 2025 [5]",
  },
  {
    title: "Validation pédiatrique multicentrique",
    quote:
      "Étude OPPORTUNITY et travaux ultérieurs : excellente capacité à exclure une infection bactérienne et à soutenir la décision clinique dans des contextes pédiatriques d'urgence ou de soins non programmés.",
    src: "van Houten et al., Lancet Infectious Diseases [4] · Kalmovich et al., Pediatrics 2025 [8]",
  },
];

const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 bg-[#0A1128]/60"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="max-w-2xl mb-16 nx-fade">
          <div className="text-xs uppercase tracking-[0.2em] text-[#5BC4D1] font-medium mb-4">
            Preuves cliniques
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light leading-tight tracking-tight">
            Une technologie{" "}
            <span className="font-semibold">validée scientifiquement.</span>
          </h2>
          <p className="mt-5 text-slate-300 leading-relaxed">
            MeMed BV® est soutenu par des études cliniques multicentriques,
            des essais randomisés et des données issues de la pratique réelle
            — publiés dans les principales revues internationales.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <article
              key={t.title}
              data-testid={`testimonial-${i}`}
              className="nx-fade bg-[#0E1530] border border-white/10 rounded-2xl p-8 hover:border-[#5BC4D1]/30 transition-colors"
            >
              <Quote size={22} className="text-[#5BC4D1]" strokeWidth={1.6} />
              <h3 className="mt-5 font-display text-lg font-medium text-white leading-snug">
                {t.title}
              </h3>
              <blockquote className="mt-4 text-slate-300 leading-relaxed text-[14px]">
                {t.quote}
              </blockquote>
              <div className="mt-6 pt-6 border-t border-white/5">
                <div className="text-xs text-slate-400 tracking-wide leading-snug">
                  {t.src}
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-10 text-center text-xs text-slate-500 max-w-3xl mx-auto leading-relaxed">
          Les dispositifs MeMed Key® et MeMed BV® sont destinés à être utilisés
          par des professionnels de santé conformément à leur destination prévue.
          Lire attentivement les instructions figurant sur l&apos;étiquetage
          et la notice d&apos;utilisation.
        </p>
      </div>
    </section>
  );
};

export default Testimonials;
